<div class="blog-posts-area bg-ffffff mt-25 pb-90">
  <div class="container" *ngIf="news_video.length > 0">
    <div class="section-title d-flex align-items-center justify-content-between mb-4">
      <h2 class="heading-title">AfroTech News</h2>
      <a href="https://youtube.com/playlist?list=PLRoijlTTy4ti3jm5PUxVGciQNYFgT4Otn&si=qpx75SefqwH7r56d" target="_blank" class="text-decoration-none">
        Découvrir toutes nos actualités <i class="ri-arrow-right-s-line"></i>
      </a>
    </div>

    <owl-carousel-o [options]="blogSlides" class="afro-carousel">
      <ng-container *ngIf="news_video && news_video.length">
        <ng-template carouselSlide *ngFor="let video of news_video">
          <div class="single-video-card bg-white rounded shadow-sm p-3">
            <app-youtube-lazy
              [videoId]="video.videoId"
              [title]="video.title"
              [badge]="video.badge"
              [date]="video.date">
            </app-youtube-lazy>
          </div>
        </ng-template>
      </ng-container>
    </owl-carousel-o>
       
    
  </div>
</div>
